module.exports = __webpack_public_path__ + "static/engineering-60e7324434319e77025cb0a927f2bdcf.jpeg";